import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// [修复] token 本地过期时长（毫秒），7天，用于本地主动判断过期
const TOKEN_EXPIRE_MS = 7 * 24 * 60 * 60 * 1000

export const useUserStore = defineStore('user', () => {
  const token = ref('')
  const userInfo = ref(null)
  const tokenExpire = ref(0)

  const checkLogin = () => {
    const savedToken = uni.getStorageSync('token')
    const savedExpire = uni.getStorageSync('tokenExpire') || 0
    if (savedToken) {
      // 本地过期校验：过期则主动登出
      if (savedExpire && Date.now() > savedExpire) {
        token.value = ''
        userInfo.value = null
        tokenExpire.value = 0
        uni.removeStorageSync('token')
        uni.removeStorageSync('userInfo')
        uni.removeStorageSync('tokenExpire')
        return
      }
      token.value = savedToken
      tokenExpire.value = savedExpire
      const savedUserInfo = uni.getStorageSync('userInfo')
      if (savedUserInfo) {
        try {
          userInfo.value = JSON.parse(savedUserInfo)
        } catch (e) {
          console.error('Failed to parse userInfo', e)
        }
      }
    }
  }

  const setToken = (newToken) => {
    token.value = newToken
    if (newToken) {
      const expire = Date.now() + TOKEN_EXPIRE_MS
      tokenExpire.value = expire
      uni.setStorageSync('token', newToken)
      uni.setStorageSync('tokenExpire', expire)
    } else {
      tokenExpire.value = 0
      uni.removeStorageSync('token')
      uni.removeStorageSync('userInfo')
      uni.removeStorageSync('tokenExpire')
    }
  }

  const setUserInfo = (newUserInfo) => {
    userInfo.value = newUserInfo
    if (newUserInfo) {
      uni.setStorageSync('userInfo', JSON.stringify(newUserInfo))
    } else {
      uni.removeStorageSync('userInfo')
    }
  }

  const logout = () => {
    token.value = ''
    userInfo.value = null
    tokenExpire.value = 0
    uni.removeStorageSync('token')
    uni.removeStorageSync('userInfo')
    uni.removeStorageSync('tokenExpire')
  }

  // 登录态：有 token 且未本地过期
  const isLoggedIn = computed(() => !!token.value && (!tokenExpire.value || Date.now() <= tokenExpire.value))

  const isAdmin = computed(() => userInfo.value?.isAdmin === true)

  checkLogin()

  return {
    token,
    userInfo,
    tokenExpire,
    checkLogin,
    setToken,
    setUserInfo,
    logout,
    isLoggedIn,
    isAdmin
  }
})
